<template>

    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg" style="max-height: 90%; overflow: auto">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey20 fWeight600">简历投递</div>
                        <div style="width: 16px;">
                            <!--<i class="icon closeIcon" @click="close()"></i>-->
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">
                    <div v-if="tipsVisible" class="f12 paddingV4 clearfix"
                         style="color: hsla(2, 100%, 73%, 1); line-height: 12px;">
                        <i class="icon warnIcon size12" style="margin-right: 6px;"></i>
                        提交信息能更快找到工作哦～
                        <i class="icon closeIcon size12 fr" @click="tipsVisible = false"></i>
                    </div>

                    <div class="marginT24" style="padding-bottom: 34px">
                        <form class="form font14r" action="javascript:;">

                            <div class="formRow clearfix" style="padding: 0 0 12px 0;">
                                <div class="fl">
                                    <label class="block formLabel">上传头像</label>
                                    <div class="font10r" style="color: #B1B4B9">*点击头像框可上传头像</div>
                                </div>
                                <div class="fr">
                                    <label class="headImageLink block circle size48 hiddenOverflow">
                                        <img class="image fullSpace" mode="aspectFill" :src="resumeForm.headImg"
                                             v-if="resumeForm.headImg"/>
                                        <i v-else class="icon addImageIcon" style="width: 48px; height: 48px;"></i>
                                        <input type="file" class="hidden" @change="onChangeHeadImageFile"/>
                                        <!-- <i class="icon plusIcon" style="width: 22px; height: 22px; position: absolute; z-index: 1;" v-else></i> -->
                                    </label>
                                </div>
                            </div>

                            <div class="formRow">
                                <label class="formLabel block">姓名</label>
                                <div class="marginT12">
                                    <input class="inputbox noOutline font18r" type="text" placeholder="填写您的真实姓名"
                                           v-model="resumeForm.name"/>
                                </div>

                            </div>

                            <div class="formRow">

                                <label class="formLabel block">电话</label>
                                <div class="marginT12">
                                    <input class="inputbox noOutline font18r" type="text" placeholder="填写您的联系方式"
                                           v-model="resumeForm.phone"/>
                                </div>

                            </div>

                            <div class="formRow">
                                <label class="formLabel block">教育学历</label>
                                <div class="marginT12">
                                    <select v-model="resumeForm.educationBackground" class="educationSelect font18r">
                                        <option v-for="(item, i) in educationBackgroundList" :value="item.name"
                                                :key="i">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <!-- <input class="inputbox noOutline font18r" type="text" placeholder="选择教育学历" readonly
                                      v-model="resumeForm.educationBackground" /> -->
                                    <!-- <picker class="font18r" :range="educationBackgroundList" range-key="name"
                                      @change="onChangeEducationBackground">
                                      {{ resumeForm.educationBackground ? resumeForm.educationBackground : '选择教育学历'}}
                                    </picker> -->
                                </div>
                            </div>

                            <div class="formRow">

                                <label class="formLabel block">教育证书</label>
                                <div class="marginT12">
                                    <select v-model="resumeForm.educationCertificate" class="educationSelect font18r">
                                        <option v-for="(item, i) in educationCertificateList" :value="item.name"
                                                :key="i">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <!-- <input class="inputbox noOutline font18r" type="text" placeholder="选择教育证书" readonly
                                      v-model="resumeForm.educationCertificate" /> -->
                                    <!-- <picker class="font18r" :range="educationCertificateList" range-key="name"
                                      @change="onChangeEducationCertificate">
                                      {{ resumeForm.educationCertificate ? resumeForm.educationCertificate : '选择教育证书'}}
                                    </picker> -->
                                </div>
                            </div>

                            <div class="formRow">

                                <label class="formLabel block">意向岗位</label>
                                <div class="marginT12">
                                    <label class="jobItem"
                                           :class="{selected : arrayHelper.existElement(jobItem, resumeForm.jobIdList)}"
                                           v-for="(jobItem, i) in organizationData ? organizationData.jobList || [] : []"
                                           :key="i">
                                        {{ jobItem.name }}
                                        <input type="checkbox" class="hidden" :value="jobItem"
                                               v-model="resumeForm.jobIdList"/>
                                    </label>
                                </div>
                            </div>

                            <div class="marginT12" style="color: hsla(217, 5%, 71%, 1)">
                                <i class="icon greyWarnIcon size12 marginR4"></i>
                                点击相应的标签可选择意向岗位
                            </div>

                            <div class="formRow">

                                <label class="formLabel block">期望薪资</label>
                                <div class="marginT12" style="display: flex;">
                                    <select v-model="resumeForm.salaryMin" class="salarySelect">
                                        <option :value="0">面议</option>
                                        <option v-for="item in 30" :value="item" :key="item"
                                                :disabled="resumeForm.salaryMax ? (resumeForm.salaryMax <= item ? true : false) : false">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <div style="margin: 0 6px;" v-if="resumeForm.salaryMin !== 0">—</div>
                                    <select v-model="resumeForm.salaryMax" class="salarySelect"
                                            v-if="resumeForm.salaryMin !== 0">
                                        <option v-for="item in 30" :value="item" :key="item"
                                                :disabled="resumeForm.salaryMin ? (resumeForm.salaryMin >= item ? true : false) : false">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <div
                                        style="ont-size: 14px;font-weight: 500;line-height: 24px;color: #333333;margin: 0 6px;"
                                        v-if="resumeForm.salaryMin !== 0">千/月
                                    </div>
                                </div>
                            </div>

                            <div class="formRow">

                                <label class="block formLabel">意向工作地</label>
                                <div class="marginT12" style="display: flex;">

                                    <select v-model="selectedProvince" class="salarySelect"
                                            @change="selectProvinceChange">
                                        <option value="province">省/直辖市</option>
                                        <option v-for="(item, i) in citiesList" :value="item" :key="i">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <div style="margin: 0 6px;">—</div>
                                    <select v-model="selectedCity" class="salarySelect" @change="selectCityChange">
                                        <option value="city">城市</option>
                                        <option v-for="(item, i) in selectedProvince ? selectedProvince.childList : []"
                                                :value="item"
                                                :key="i" :disabled="selectedProvince ? false : true">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                    <div style="margin: 0 6px;">—</div>
                                    <select v-model="selectedArea" class="salarySelect">
                                        <option value="area">区/镇/县</option>
                                        <option v-for="(item, i) in selectedCity ? selectedCity.childList : []"
                                                :value="item" :key="i"
                                                :disabled="selectedCity ? false : true">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="formRow">

                                <label class="formLabel block">工作经验</label>
                                <div class="marginT12">
                  <textarea style="width: 100%; height: 46px;" class="inputbox noOutline font18r" type="text"
                            placeholder="填写您的工作经验" v-model="resumeForm.workExperience"/>
                                </div>
                            </div>

                            <div class="formRow" style="border-bottom: none;">
                                <div class="clearfix">
                                    <div class="fl">
                                        <label class="formLabel block">推荐优质园所</label>
                                    </div>
                                    <div class="fr">
                                        <label class="block sortItem clearfix">
                                            <!-- <span class="fl">{{sortTypeItem.title}}</span> -->
                                            <input class="fr modernCheckbox orangeCircleTickCheckbox" type="checkbox"
                                                   v-model="resumeForm.isPublic"/>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                style="font-size: 12px;font-family: Source Han Sans CN;font-weight: 400;line-height: 12px;color: #B1B4B9;opacity: 1;">
                                <i class="icon greyWarnIcon size12 marginR4"></i>
                                允许平台推荐您的简历增加应聘机率
                            </div>

                            <div class="formRow">
                                <label class="formLabel block" style="color: #8994A9;">上传图片简历</label>
                                <div class="marginT12">
                                    <label>
                                        <i v-if="resumeUploading" class="icon spinner-loader"
                                           style="position: absolute;left: 39px;bottom: -84px;"></i>
                                        <i v-if="!resumeForm.resume" class="icon addImageIcon"
                                           style="width: 84px; height: 84px;"></i>
                                        <img v-else :src="resumeForm.resume" :alt="resumeForm.resume"
                                             style="width: 84px; height: 84px; object-fit: cover;"/>
                                        <input type="file" class="hidden" @change="upResumeChange"/>
                                    </label>
                                </div>
                            </div>

                            <div class="optArea paddingV16">
                                <div class="button cancelButton font16r fl" @click="close()">取消</div>
                                <div class="button submitButton font16r fr" @click="submit()">投递</div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from "../../part/drawerPart";

// data
import citiesList from '@/data/citiesList_v2'

// api
import seekerApi from '../seekerApi';
import fileApi from "@/api/file";
import recruitSeekerApi from "../recruitSeekerApi";

// platformApi
import requestManager from "@comp/platformApi/requestManager.js";

// util
import appHelper        from "@/util/appHelper";
import consoleHelper    from "@/util/consoleHelper";
import objectHelper     from "@/util/objectHelper";
import arrayHelper      from "@/util/arrayHelper";
import administrativeAreaHelper from '@/util/administrativeAreaHelper';

administrativeAreaHelper.init(citiesList);

const config = {
    apiConfig: {
        list: {
            url: "",
            dataPath: "data.records",
            totalPagePath: "data.pages",
            dataColumnMapping: {
                // userName : 'name''
            },
        },
        sendResume: {
            method: "post",
            url: "/portal/recruit/seeker/add",
        },
        get: {
            url: "",
            dataColumnMapping: {
                // userName : 'name'
            },
        },
    },

};

export default {
    name: "editContactInfoDrawer",
    extends: drawerPart,
    props: {
        organizationData: {
            type: Object,
            default() {
                return {}
            }
        },
        parkData: {
            type: Object,
        },
        jobData: Object,
    },
    data() {
        return {
            apiConfig: config.apiConfig,
            citiesList: citiesList,
            resumeForm: {
                parkId: "",
                name: "",
                headImg: "",
                phone: "",
                educationBackground: "",
                educationCertificate: "",
                salaryMin: 1,
                salaryMax: 9,
                workExperience: '',
                isPublic: true,
                jobIdList: [],
                resume: ""
            },
            arrayHelper: arrayHelper,
            tipsVisible: true,
            resumeUploading: false,
            selectedProvince: 'province',
            selectedCity: 'city',
            selectedArea: 'area',
            educationBackgroundList: [],
            educationCertificateList: [],
        };
    },
    methods: {
        init(data) {
            this.visible = true;
            this.resumeForm.parkId = data.parkId;
            this.getLastSeekerInfo();
        },
        getLastSeekerInfo() {

            const me = this;

            let getLastSeekerInfoOptions = objectHelper.clone(seekerApi.getLastSeekerInfo);
            getLastSeekerInfoOptions.data = {
                isResume: true
            };
            requestManager.request(getLastSeekerInfoOptions, (error, result) => {
                if (error) {
                    consoleHelper.logError(error);
                    return;
                }

                if (result.data) {
                    me.resumeForm.name = result.data.name;
                    me.resumeForm.headImg = result.data.headImg;
                    me.resumeForm.phone = result.data.phone;
                    me.resumeForm.educationBackground = result.data.educationBackground || me.educationBackgroundList[2].name;
                    me.resumeForm.educationCertificate = result.data.educationCertificate || me.educationCertificateList[0].name;
                    me.resumeForm.salaryMin = result.data.salaryMin || 1;
                    me.resumeForm.salaryMax = result.data.salaryMax || 9;
                    me.resumeForm.workExperience = result.data.workExperience;
                    me.resumeForm.isPublic = result.data.isPublic || true;
                    me.resumeForm.resume = result.data.resume;
                }
            });
        },
        submit() {
            let reqOptions = this.apiConfig.sendResume;
            reqOptions.data = Object.assign({}, this.resumeForm);
            reqOptions.data.jobIdList = this.formatIds(this.resumeForm.jobIdList);
            reqOptions.data.province = this.selectedProvince.name;
            reqOptions.data.city = this.selectedCity.name;
            reqOptions.data.area = this.selectedArea.name;
            requestManager.request(reqOptions, (error, result) => {
                if (error) {
                    return;
                }
                if (result.errorCode) {
                    appHelper.showMessage(result.msg);
                    return;
                }
                appHelper.showHint("信息提交成功啦！~");
                this.close();
            });
        },
        formatIds(list) {
            let ids = [];
            for (let i = 0; i < list.length; i++) {
                ids.push(list[i].id);
            }
            return ids.join(",");
        },
        upResumeChange(e) {
            this.resumeUploading = true;
            let file = e.srcElement.files[0];

            let uploadOptions = objectHelper.clone(fileApi.upload_image());

            requestManager.uploadFile(uploadOptions, file, (error, result) => {

                if (error) {
                    appHelper.showMessage("上传出错了，请稍后再试吧~");
                    this.resumeUploading = false;
                }

                this.resumeForm.resume = JSON.parse(result).data;
                this.resumeUploading = false;
            });
        },
        onChangeHeadImageFile(e) {
            this.resumeUploading = true;
            let file = e.srcElement.files[0];

            let uploadOptions = objectHelper.clone(fileApi.upload_image());

            requestManager.uploadFile(uploadOptions, file, (error, result) => {

                if (error) {
                    appHelper.showMessage("上传出错了，请稍后再试吧~");
                    this.resumeUploading = false;
                }

                this.resumeForm.headImg = JSON.parse(result).data;
                this.resumeUploading = false;
            });
        },
        selectProvinceChange(e) {
            this.selectedCity = 'city';
            this.selectedArea = 'area';
        },
        selectCityChange(e) {
            this.selectedArea = 'area';
        },
        close() {
            for (let key in this.resumeForm) {
                this.resumeForm[key] = key == "jobIdList" ? [] : "";
            }
            this.visible = false;
        },
    },

    mounted() {
        recruitSeekerApi.getEducationBackgroundList((list) => {
            this.educationBackgroundList = list;
            if (list.length >= 3) {
                this.resumeForm.educationBackground = list[2].name;
            }
        });

        recruitSeekerApi.getEducationCertificateList((list) => {
            this.educationCertificateList = list;
            if (list.length >= 1) {
                this.resumeForm.educationCertificate = list[0].name;
            }
        });

        this.getLastSeekerInfo();
    }
};
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACD0lEQVRIibWWP26jQBTGp3LKeLchrRHeCM0fkKNEcjXSVr7AHMBNbsAN0uUicRSOEEdabUdjfIFIaEQFuBkkCpuXYnGUtWeAZL1PetWI3zfzvTfzQKglHMc5I4RYruuO6Z+4apK6rjsmhFiO45y1MYxgSqmNMb72PO+mLTHG15RSu7cQxvg7pfSqC3yYzcm+dcEv+uy67TQY4wst3Pf94b/AP4r4vj/Uef5pW9rs+qsmlFL7VPB9MsZGe98HOmvCMLyN4/i+CxTH8X0YhreGegwQIcTSfZhl2RIA6iRJHkxwKeUDANRZlr3o1gkhFvI874duMQiCWVVVrwBQSymPRJIkWQBAXVXVaxAEMx3Ddd0xopRS0w5NIn3gTbEpYoxN2jwOgmBWluW6sWshpVwAwK4sy/V8Pv/ZUehJp4DneTdCCK6UWgNADQC1UmothOA9OmnSatE+OefToiiW0ERRFEvO+bTHfaCIMXbZBc/z/BkAdkqpWCkVA8Auz/PnLhHG2KWxTTXwlRCCN3at+ogQQizjReOcT7MsewGA7R5+UJMVAGxNdr1fNIQQYoyNDH2+LYril66gQgi+2Wx+A8BOSvmosWf08ZkeHHZTFEV3aZo+tVnAOZ+mafoURdHdYfe8734ftm2fn+q5tm37/L8NHEKI1TrVfN8ffnVkHg0aU2CMB58Z+oyx0ZHnfeIUvy1vjeomB0FzNDwAAAAASUVORK5CYII=');
    }
}

.warnIcon {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACCUlEQVRIiZVWIXLjQBBcEHAPyANcFf8grkrggQMHrir3hDwgVQHy9u7OOhXxAwfuAQJ+QKBBgICfYSBoECgQENAHdi3LsbTaCKmknume1uyMlEpcXOkrCgo6vaFDQ8E7BS0dGjq9oaDgSl+lciQS64oCUkA67OlNTTEVxVT0pqbDvnsvusomojd3FLQUfFBMReB2FAvcBlKQgpbe3KWTi3mM4B09FtkVeywo2IVY85hSTorZsiguB8iDUm/qwfiiuKSYbcScVkJr59GW3VDyqPJfiuBIgh0FLa2d99VXFHykbKHgeYogCllEXNVXT0p8MEUgeEnhAjbaae1cUVBQwFS3hCB9nyNEqUN3gRQUis680mE/rSoSOP1nChvxb/TYKAqaKV+VUop2+SOqes4i8KamoFHh+GeUvbLfg694yKvArClo8wm6ZtD3XyXItMjOQgX6ZxZBZ5Ezr/R6+iOX5QWtnbEsv+VVcPzIWW0aSfKSn7TpwVs/cdAOo8LpmmV5kcb2DlooJ46KJ3s9GiTmvZv//TnzGfdkr88OZN6wM39DBWa0gk/Dbnb60uF3VDg4rqeumHwbbfw1DOovnIRdZ3HBll3cgsMLpwOHStpu17rlzTh2edPb3e2o8rNAa+e9XUs6vafTNUWvKXod79+OS99UZ57nE6Ggx4aCJlbWhtOP8NuS6CillPoP4lk4kl8eIhoAAAAASUVORK5CYII=);
}

.greyWarnIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABiElEQVQ4jYVTK3IbQRAdYBAeYhAgHlXFVTb3wsAAH8BVVpV9A8OIBywQCNQJrJn+7cwbu8pARzBYsECHWCjggJVUK2mlNJv+vO5+89q5A5OUfpCiJE11ELRB0JKmmhQlp/T9MH9n0+n7BWmekWJNBgmWJl5i4SUWwdKEDEKKNWmeTafvF8fFkpekaMjsxjnnXqrqW9C0Coo/2zwyuyFFQ5KXeyBk+S8pGjO73Pq8jyNSfJLmWb+ZmV2Sotn5veWrbuyu8xGA4ffhuptJ1gvF2LGiJIMM8UKKT9b0PBjrOCkdK+pgaXISgPP9YEzSEys+HAlaL7E4AbAKgruhmJdYBEH7X4BTMS+xIEHrWFGz4mEoiRUP3sfR2RXOkbh4e/s65HeuI5EVpVsoxqRYe8X1fkL6uVXlcXHvG7td8+xISBV+dUJKr/3ijZBWewLb3MGSBE1/Eh/jaD6ff9m9FdcbFS6H76F/TJwfucq3XOXbwPnx7DHtEacYs6JkRU2ClgQtKz5YUe527tk/hn5aIbWgBnkAAAAASUVORK5CYII=');
}

.addImageIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAACoCAYAAAB0S6W0AAAEuklEQVR4nO3YMY8bRRjG8ZGIIvJBUkV8AZp8PUQTClIhJOhSUELPF4CWIsXMjhcp68Ui9tk7s0L4pfJhWZcU0TPad5P/Sr/uVpl77h/rbkK4eYZh+DLn/oecN8eUunOMyS7GcbRSyjuN42jXX3+L93n/gfdOpZTX0zS9mOf5i9se7x8z+2yapm+7Lp9X9g3y/kfw/jRNlvPm3Pf9KzN7fBvno1rrL6UU2+129ubNYPv93k6n03sPBKi8fbu/D7nrNr+b2ZP7QGut3yx9QGC/31tKncWYbLPpfwohhDDP87Na6z9LHw4opdjhcLAYk6XUncdxfB5qrS+XPhRwbRi2FmOynPtXoZTyx9IHAq5dPkVzzvtQaz0tfSDg2jRNdnd3Z6WUU7j85bT0oYCHEChcI1C4RqBwjUDhGoHCNQKFawQKly5dhqUPAjyEQOEagcI1AoVrBArXCBSuEShcI1CsAhf1cI1A4RqBwjUChWsECtcIFK4RKFwjULjERT1cI1C4RqBwjUDhGoHCNQKFawQK1wgUq8BFPVwjULhGoHCNQOEagcI1AoVrBArXCBQucVEP1wgUrhFoo0H5lUm7J4GKByVQ7Z4EKh6UQLV7Eqh4UALV7kmg4kEJVLsngYoHJVAtLupFCLQNAhUh0DYIVIRA2yBQEQJtg0BFCLQNAhUh0DYIVIRA2yBQEQJtsycX9eJBCVS7J4GKByVQ7Z4EKh6UQLV7Eqh4UALV7kmg4kEJVLsngYoHJVDtngQqHpRAtXsSqHhQAtXiol6EQNsgUBECbYNARQi0DQIVIdA2CFSEQNsgUBECbYNARQi0DQIVIdA2e3JRLx6UQLV7Eqh4UALV7vnRBHobyKdu6Z8HgRIoga7J0kF4s/TPg0AJlEDx4f9Blj7P2hFoo0EJVIuLehECbYNARQi0DQIVIdA2CFSEQNsgUBECbYNARQi0DQIVIdA2CFSEQNvsyUW9eFAC1e5JoOJBCVS7J4GKByVQ7Z4EKh6UQLV7Eqh4UALV7kmg4kEJVLsngYoHJVDtngQqHpRAtbioFyHQNghUhEDbIFARAm2DQEUItA0CFSHQNghUhEDbIFARAm2DQEUItM2eXNSLByVQ7Z4EKh6UQLV7Eqh4UALV7kmg4kEJVLsngYoHJVDtngQqHpRAtXsSKFwiUKwCF/VwjUDhGoHCNQKFawQK1wgUrhEoXCNQuMRFPVwjULhGoHCNQOEagcI1AoVrBArXCBSrwEU9XCNQuEagcI1A4RqBwjUChWsECtcIFC5xUQ/XCBSuEShcI1C4RqBwjUDhGoHCNQLFKnBRD9cIFK4RKFwjULhGoHCNQOEagcI1AoVL9xf1MaZzjMmmaVr8UEApxU6n6RLoOfT9n38Pw5ZA4cbhcLAYk+Wc96HW+nLpAwHXhmFrMSbruvxjmOf5WSnl36UPBZTy/6dnjMnGcXweQgihlPLd0gcDpmmylDqLMVnf9z+Hy2Nmj0spv15/8fF4XPzA+PSM42hdl3/bbDZPwvVjZo9qrV+XUubj8Xj/MfuQcfzrvf/IdjvyPu9/yPtzrfWrGOPn4V1PrfXpbrf7PufNMaXuvLJvkPdX9n6t9VRKeV1rfVFrfXrb43+sAi5ffA82nQAAAABJRU5ErkJggg==');
}

.form {
    .formRow {
        padding: 24px 0 12px;
        border-bottom: 1px solid hsla(0, 0%, 94%, 1);
    }

    .formLabel {
        color: hsla(219, 9%, 39%, 1);
    }

    .inputbox {
        background: transparent;
        border: none;
        color: hsla(0, 0%, 20%, 1);
    }

    .jobItem {
        display: inline-block;
        height: 1.5714em;
        line-height: 1.5714em;
        padding: 0 0.57em;
        //font-size: 87.5%;
        border: solid 1px transparent;
        color: #b8c2d6;

        border-radius: 12px;

        margin-right: 12px;
        margin-bottom: 12px;

        &:last-child {
            margin-right: 0;
        }

        &.selected {
            border-color: #ffcf86;
            color: #ffa724;
        }
    }
    .optArea {
        .button {
            height: 36px;
            line-height: 36px;
            border-radius: 20px;
            width: 48%;

            &.cancelButton {
                background: #f7f7f7;
                color: hsla(220, 27%, 78%, 1);
            }

            &.submitButton {
                background: #ffb444;
                color: white;
            }
        }
    }
}

.salarySelect {
  width: 78px;
  height: 24px;
  background: #f2f2f2;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  appearance: none; /* 去掉默认图标 */
  // padding: 0 10px;
  text-align: center;
  text-align-last: center;
}

.educationSelect {
    width: 100%;
    background: transparent;
    border: none;
    color: hsla(0, 0%, 20%, 1);
}
</style>
